module.exports = {
    namespace: 'users',

    da: {
        account: {
            avatar: {
                title: 'Profilbillede',
                newImage: 'Dit nye billede',
                currentImage: 'Dit nuværende billede',
                requirementsHelp: 'Du kan kun bruge .png og .jpg filer, på minimum være 300 gange 300 pixels.',
                uploadSuccess: 'Dit nye billede er blevet gemt, og det vil være synligt om et øjeblik. Du skal bare genindlæse siden.',
                uploadError: 'Der skete en fejl da vi forsøgte at gemme dit billede. Prøv venligst igen.',
            },
        },
    },

    en: {
        account: {
            avatar: {
                title: 'Profile picture',
                newImage: 'Your new picture',
                currentImage: 'Your current picture',
                requirementsHelp: 'You can only use .png and .jpg files, with a minimum size of 300 by 300 pixels.',
                uploadSuccess: 'Your new picture ahs been saved and will be visible in a moment. You just have to refresh this page.',
                uploadError: 'An error occurred while trying to save your picture. Please try again.',
            },
        },
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/users/locales/index.js